document.addEventListener('DOMContentLoaded', function () {

  const searchContainer = document.querySelector('#MiniInlineSearch');
  const searchInput = document.querySelector('#MiniInlineSearchInput');
  const closeButton = document.querySelector('#MiniInlineSearchClose');
  const searchResults = document.querySelector('#MiniInlineSearchResults');

  if (!searchContainer || !searchInput) return;


  /* FIND DAWN SEARCH ICON */

  const searchButton = document.querySelector(
    '.header__icon--search'
  );

  if (!searchButton) return;


  /* OPEN INLINE SEARCH */

  searchButton.addEventListener('click', function (event) {

    event.preventDefault();
    event.stopPropagation();

    searchContainer.classList.add('is-open');

    setTimeout(function () {
      searchInput.focus();
    }, 150);

  });


  /* CLOSE */

  if (closeButton) {

    closeButton.addEventListener('click', function () {

      searchContainer.classList.remove('is-open');

      searchInput.value = '';

      searchResults.innerHTML = '';

    });

  }


  /* SEARCH */

  let searchTimer;

  searchInput.addEventListener('input', function () {

    clearTimeout(searchTimer);

    const query = searchInput.value.trim();

    if (!query) {

      searchResults.innerHTML = '';

      return;

    }

    searchTimer = setTimeout(function () {

      fetch(
        window.Shopify.routes.root +
        'search/suggest.json?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product' +
        '&resources[limit]=6'
      )

      .then(function (response) {
        return response.json();
      })

      .then(function (data) {

        searchResults.innerHTML = '';

        if (
          !data.resources ||
          !data.resources.results ||
          !data.resources.results.products ||
          !data.resources.results.products.length
        ) {

          searchResults.innerHTML =
            '<div class="mini-search-no-results">No products found</div>';

          return;

        }


        data.resources.results.products.forEach(function (product) {

          const item = document.createElement('a');

          item.className = 'mini-search-product';

          item.href = product.url;

          item.innerHTML = `

            <img
              src="${product.image || ''}"
              alt="${product.title}"
              loading="lazy"
            >

            <div class="mini-search-product__info">

              <span class="mini-search-product__title">
                ${product.title}
              </span>

              ${
                product.price
                ? `<span class="mini-search-product__price">
                    ${product.price}
                   </span>`
                : ''
              }

            </div>

          `;

          searchResults.appendChild(item);

        });

      })

      .catch(function () {

        searchResults.innerHTML = '';

      });

    }, 250);

  });


  /* ESCAPE TO CLOSE */

  document.addEventListener('keydown', function (event) {

    if (
      event.key === 'Escape' &&
      searchContainer.classList.contains('is-open')
    ) {

      searchContainer.classList.remove('is-open');

      searchInput.value = '';

      searchResults.innerHTML = '';

    }

  });

});